

const counterUAVConfig = () => {
    const config = {
        radius: 0.0055,
        duration: 20000,
        cost: 35,
    }
    return config;
}

export default counterUAVConfig;